import "react-loading-skeleton/dist/skeleton.css";
import {
  TableCell,
  TableRow,
  styled,
  tableCellClasses,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";

export const CustomTooltip = styled((props: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: props.className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: "10px",
    fontWeight: 600,
    margin: "0 !important",
    backgroundColor: "#ffffff !important",
    color: "#313131 !important",
    boxShadow: "0 1px 8px #0003",
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 150,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: "48px",
  "&:hover": {
    background: theme.palette.action.hover,
    cursor: "pointer",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.mode === "dark" ? "#1E1E2F" : "#F8F8FF",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
;
